import { render } from "./AppHeader.vue?vue&type=template&id=48f394ab&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=48f394ab&lang=scss&scoped=true"

import exportComponent from "D:\\git\\tim\\tim-sign-ui_imza.ebirlik.net\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f394ab"]])

export default __exports__